import { useReducer } from 'react';

export function useToggle(initialValue = false): [value: boolean, toggle: () => void] {
  return useReducer((value) => !value, initialValue);
}
